module.exports = __webpack_public_path__ + "files/0ce7b8c5a9ebea0f4d846062a217650d.png";